.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2xs);

  margin: 0;
  padding: 0;

  list-style: none;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3xs);

  padding: 1px var(--space-xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  line-height: 1.5;
  white-space: nowrap;

  color: var(--accent-strong);
  background-color: var(--accent-soft);

  border-radius: var(--radius-pill);
}

.empty {
  font-size: var(--size-200);

  color: var(--text-faint);
}

.editor {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);
}

.label {
  font-size: var(--size-200);
  font-weight: var(--weight-medium);

  color: var(--text-muted);
}

.hint {
  font-size: var(--size-100);

  color: var(--text-faint);
}

/* The chips and the input share one bordered box, so the whole reads as one field. */
.field {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2xs);

  padding: var(--space-2xs) var(--space-xs);

  background-color: var(--field);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);
}

.field:focus-within {
  border-color: var(--accent);
  box-shadow: var(--ring);
}

.input {
  flex: 1 1 8rem;

  padding: var(--space-3xs) 0;
  min-width: 6rem;

  font-size: var(--size-300);

  color: var(--text);
  background-color: transparent;

  border: none;
  outline: none;
}

.remove {
  display: inline-flex;
  align-items: center;

  padding: 0;

  font-size: 0.85em;

  color: inherit;
  background-color: transparent;

  border: none;
  border-radius: var(--radius-pill);

  cursor: pointer;
}

.remove:hover {
  color: var(--band-missing);
}

.add {
  padding: var(--space-3xs) var(--space-xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);

  color: var(--text);
  background-color: transparent;

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-m);

  cursor: pointer;
}

.add:disabled {
  opacity: 0.5;

  cursor: not-allowed;
}
